import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import moment from 'moment'
import printJS from 'print-js'
import Printd from 'printd'
import CryptoJS from 'crypto-js'
import SimpleEncrypt from 'simple-encryptor'

import {
	Validator
} from 'vee-validate'
export default {
	name: 'po',

	components: {
		Paginate,

	},
	props: ['pono1'],
	data: function() {
		return {
			// initialize form field
			isLoading: false,
			PurchaseOrderDetailsData: [],
			PurchaseOrderLoopData: [],
			clientdata: [],
			supplierdata: [],
			logoUrl: '',
      boxdatas : [],
			pono: '0',
			poform: {},
			loading: false,
			loadingText: '<i class="fa fa-spinner fa-spin"></i> Loading...',
			warehouseid: '',
			clientid: ''
		}
	}, // end data
	model: {
		totalpricewithtax: 0,
		sgst: 0,
		cgst: 0,
		igst: 0,
		totalpricewithouttaxes: 0,

	},
	computed: {

	}, // end computed

	created: function() {
		// when a page loads,mounted() will be call
	},
	mounted() {
		this.key = '5VxHu9PR8QgPq7h67cUG0H34rYZQZmey';
		this.encryptor = SimpleEncrypt(this.key);
		console.log(this.pono1);
		this.getBoxDatas();
	},
	filters: {
		moment: function(date) {
			return moment(date).format('DD-MM-YYYY');
		}
	},
	methods: {
		showList() {
			this.$emit("goBackToParent")
		},
		encryptData(encData){
       return this.encryptor.encrypt(encData);
		},
		decryptData(decData){
			return this.encryptor.decrypt(decData);
		},
		print() {
			const d = new Printd();
			var buffer = '';

			var cssText = `
   body{
  -webkit-print-color-adjust:exact;
}
   table {
       border-collapse: collapse;
       margin-left:0px !important;
   }

   table, td, th {
     border-style: solid;
border-width: 1px;

margin-bottom: 10px;
border-color: rgba(0,0,255,0.25);
       padding:5px;
   }
 pre {
   color: #c7254e;
 }
 .text-right{
   text-align:right;
 }

 .clientdetails{
   margin-top:-40px;
   font-size:12px;
 }
 .row{
	 width : 1000px;

 }
 .col-md-3{
	 width : 250px;
 }
 @media print {
 .text-primary th{
   background-color:rgb(226, 216, 216) !important;
   color:black !important;
   font-size:20px !important;
 }

}
`
			d.print(document.getElementById('printContent'), cssText);
		},
		onLoadingStart() {
			this.loading = true;
		},
		onLoadingEnd() {
			this.loading = false;
		},
		getLocalUserData() {
			var userdetailEncrypt = window.localStorage.getItem('userdetail')
			var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
			var plaintext = bytes.toString(CryptoJS.enc.Utf8);
			var userdetail = JSON.parse(plaintext);
			return userdetail;
		},
		getBoxDatas() {
			let userToken = window.localStorage.getItem('userToken')
			let myStr = userToken.replace(/"/g, '');
			this.input = ({
				'clientid': this.pono1.clientId,
				'warehouseid' : this.pono1.warehouseId,
				'orderid': this.pono1.orderId,
				'boxid': this.pono1.boxId,
			});

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'packing/getBoxData',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
				if (result.data.data.ErrorCode == 0) {

					this.boxdatas = result.data.data.data.boxData
					//console.log(this.boxdatas)
				}
				});
	}


	}

	// end methods
}



// WEBPACK FOOTER //
// ./src/views/components/packingnew/printpackdata.component.js